import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import Routes from "Configs/routes";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import { generateUrl } from "Services/withDefaultParams";
import { isMoscowSiteCode } from "Utils/siteConfig";

let LIMIT = 35;
@withRouter
@inject("ApplicationModel")
@observer
export default class PaginationContainer extends FiltersLoadParams {
	render() {
		let {
			ApplicationModel: { windowSizeModel, siteCode },
			match,
			location,
			pagination,
			isMoscowSiteCodeReview,
			generationUrl,
		} = this.props;

		if (isMoscowSiteCodeReview && isMoscowSiteCode(siteCode)) {
			LIMIT = 20;
		}


		let path = generateUrl(generationUrl, {
			regionUrl: match.params.regionUrl,
			search: location.search,
		});
		let pageTotal = Math.ceil(pagination.items_total / LIMIT);
		let page = 1;
		if (match.params.page) {
			page = match.params.page;
		}

		return (
			<Paginator
				key={23}
				itemsTotal={pagination.items_total}
				itemsPerPage={LIMIT}
				pageCurrent={page}
				pageTotal={pageTotal}
				windowSizes={windowSizeModel.windowSizes}
				urlDefault={path}
				wrapperItem={<PaginatorElem />}
				location={location}
				datatest="providers"
			/>
		);
	}
}
